import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { SmallTeaserImageProps } from '../Types'
import { SmallTeaserImage } from '../Components'
import VideoLabel from '../../../../BaseComponents/Labels/Video'

const SmallTeaserArticleImage = ({
    imageUrl,
    alt,
    teaserIcon,
}: SmallTeaserImageProps): ReactElement => {
    return (
        <Grid noExpand width={140} position="relative">
            <SmallTeaserImage imageUrl={imageUrl} alt={alt} />
            {teaserIcon === 'VIDEO' ? <VideoLabel padding={2} margin={3} iconSize="S" /> : null}
        </Grid>
    )
}

export default SmallTeaserArticleImage
